import React from 'react';

const CommonLoading = () => (
  <div className="preloading preloading-box"><p>Loading</p></div>
);

export default CommonLoading;
